import {
  Box,
  Card,
  CircularProgress,
  Stack,
  Typography,
} from "@mui/material";
import { useSelector } from "react-redux";
import MoneyOffIcon from "@mui/icons-material/MoneyOff";

const PublisherDashboardChargeback = () => {
  const { data: publisherRevenue, loading } = useSelector(
    (state) => state.publisherRevenueDetails
  );
  
  return (
    <>
      <Card sx={{ p: 2, color: '#0C6A96' }}>
        <Stack direction='row' justifyContent='space-between'>
          <MoneyOffIcon color='#0C6A96' />
          <Typography sx={{ color: '#5E6C8A', fontFamily: 'Montserrat,sans-serif', fontStyle: 'normal' }} variant='subtitle2'>
            Chargeback Amount
          </Typography>
        </Stack>

        {loading ? (
          <CircularProgress />
        ) : (
          <Box>
            <Typography variant='h3' sx={{ fontWeight: 600, color: '#071D45' }}>
              {publisherRevenue?.chargebackTotalAmount 
                ? publisherRevenue?.chargebackTotalAmount?.toFixed(4) 
                : "0.0000"}
            </Typography>
          </Box>
        )}
      </Card>
    </>
  );
};

export default PublisherDashboardChargeback;
